import React, { useState, useEffect } from "react";
import Box from "../Box";
import Menu from "./Menu";
import Avatarr from "./Avatar";
import applicationlogo from "@assets/logo/bimbild_logo.png";
import Logo from "./Logo";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import SC from "./style";
import { useSelector } from "react-redux";
import jenny from "../../../assets/jenny.png";
import rolesIcon from "../../../assets/icons/rolesIcon.png";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import TimeDisplay from "components/TimeDisplay";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import styled from "@emotion/styled";
import TooltipText from "components/TooltipText";
import InnoIcons from "@InnoIcons/";
import themes from "@theme";

const drawerPaperStyles = (theme) => ({
  [theme.breakpoints.up(300)]: {
    marginTop: "55px !important",
  },
});

function Header({ profileData, visibilityOptions }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTab = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const folderId = searchParams.get("folderId");
  const type = searchParams.get("type");
  const projectId = searchParams.get("projectId");
  const [openModalView, setOpenModalView] = useState(false);

  const authData = useSelector((state) => state?.authdata?.data || []);
  const cartData = useSelector((state) => state?.cartData?.data || []);

  const roles = useSelector((state) =>
    Array.isArray(state?.userRoles?.data) ? state?.userRoles?.data : [],
  );

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || [],
  );
  const currentOccupant = useSelector(
    (state) => state?.currentOccupant?.data || [],
  );
  const location = useLocation();

  useEffect(() => {
    if (!isMobile) {
      setDrawerOpen(false);
    }
  }, [isMobile, isTab]);

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "white",
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    },
  }));

  const handleCartClick = async () => {
    if (type == 0) {
      navigate(`/cart?projectId=${currentProject.id}&type=${0}`);
    } else if (type == 1) {
      navigate(`/cart?projectId=${currentOccupant.id}&type=${1}`);
    } else if (currentProject?.id) {
      navigate(`/cart?projectId=${currentProject.id}&type=${0}`);
    } else {
      navigate(`/cart`);
    }
  };
  return (
    <div>
      {SC.Globalstyles}
      <SC.StyledAppBar>
        <SC.StyledContainer maxWidth="100%">
          <SC.StyledToolbar
            sx={{ justifyContent: "space-between", boxShadow: "none" }}
          >
            <Box>
              <Link to={"/"} style={{ textDecoration: "none" }}>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <Logo
                    alt="ApplicationLogo"
                    path={applicationlogo}
                    style={{
                      objectFit: "contain",
                      width: "50px",
                      display: "block",
                    }}
                  />
                  <span
                    style={{
                      color: themes.colors.themeColor,
                      fontSize: "20px",
                      fontWeight: "600",
                      fontFamily: "Roboto, sans-serif",
                      textDecoration: "none",
                    }}
                  >
                    Bimbild
                  </span>
                </div>
              </Link>
            </Box>

            <>
              {visibilityOptions.profileData && (
                <SC.ProfileItem>
                  <Box
                    sx={{
                      display: { xs: "none", sm: "flex" },
                      alignItems: "center",
                    }}
                  >
                    <InnoIcons.LanguageRoundedIcon
                      sx={{
                        color: themes.colors.themeColor,
                        fontSize: "45px",
                        borderRight: "1px solid #E2E4E7",
                        paddingRight: "8px",
                      }}
                    />

                    <div style={{ padding: "5px", marginRight: "10px" }}>
                      <TimeDisplay
                        timezone={currentProject?.timeZone || null}
                      />
                    </div>
                  </Box>
                  {roles && roles.length > 0 && (
                    <LightTooltip
                      title={
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <p
                            style={{
                              color: themes.colors.themeColor,
                              margin: "0 0 5px",
                            }}
                          >
                            Roles
                          </p>
                          {roles &&
                            roles.map((data, index) => (
                              <p
                                key={index}
                                style={{ margin: "2px", opacity: "0.8" }}
                              >
                                <TooltipText title={data.name} maxLength={60} />
                              </p>
                            ))}
                        </div>
                      }
                      arrow
                    >
                      <img
                        src={rolesIcon}
                        alt="Roles Icon"
                        style={{
                          borderRight: "1px solid #E2E4E7",
                          textAlign: "center",
                          cursor: "pointer",
                          margin: "10px 10px 10px 0px",
                          paddingRight: "10px",
                        }}
                      />
                    </LightTooltip>
                  )}

                  {currentProject?.id && (
                    <div
                      style={{
                        position: "relative",
                        backgroundColor: themes.colors.themeColor,
                        height: "33px",
                        width: "33px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        margin: "0px 10px 0px 5px",
                      }}
                      onClick={handleCartClick}
                    >
                      <InnoIcons.ShoppingCartIcon
                        sx={{
                          color: "white",
                          fontSize: "20px",
                        }}
                      />

                      <span
                        style={{
                          position: "absolute",
                          top: "-3px",
                          right: "-3px",
                          backgroundColor: "#0073E6",
                          color: "white",
                          borderRadius: "50%",
                          height: "16px",
                          width: "16px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "10px",
                        }}
                      >
                        {cartData.length || 0}
                      </span>
                    </div>
                  )}
                  {authData?.picture ? (
                    <img
                      alt={"Profile picture"}
                      style={{
                        height: "35px",
                        width: "35px",
                        borderRadius: "50%",
                      }}
                      src={authData?.picture}
                    />
                  ) : (
                    <Avatarr
                      alt={"Profile picture"}
                      sx={{ height: "35px", width: "35px" }}
                      src={jenny}
                    />
                  )}
                  {profileData &&
                    profileData.map((item, index) => (
                      <Menu
                        key={item.id}
                        item={item}
                        isMobile={isMobile || isTab}
                        fontWeight={"bold"}
                        fontSize={"13px"}
                      />
                    ))}
                </SC.ProfileItem>
              )}
            </>
          </SC.StyledToolbar>
        </SC.StyledContainer>
      </SC.StyledAppBar>
    </div>
  );
}

export default Header;
